import React from 'react';
import List from '@material-ui/core/List';
import { useInfiniteScroll } from 'hooks';
import strings from 'strings';
import { When } from 'UI/components/atoms';
import LoaderContent from 'UI/components/templates/DrawerContentLayout/LoaderContent';
import EmptyPlaceholder from 'UI/components/templates/EmptyPlaceholder';
import { SvgNoHiringAuthority } from 'UI/res';

import { ConversationListItem } from '../ConversationListItem';

import { Container, EmptyListContainer, ListContainer } from './ConversationsList.styled';

const COPIES = strings.messageCenter;

export const ConversationsList = ({
  conversations = [],
  isLoading,
  onClickCheckbox,
  onClickConversation,
  onFetchMoreConversations,
  searchKeyword,
  selectedConversationId,
  selectedConversations = [],
  showCheckbox
}) => {
  const { listEndRef } = useInfiniteScroll({ onScrollEndTrigger: onFetchMoreConversations });

  const handleClickConversation = selection => onClickConversation(selection);

  return (
    <Container>
      <ListContainer>
        <When condition={conversations.length === 0 && !isLoading}>
          <EmptyListContainer>
            <EmptyPlaceholder
              title={
                searchKeyword
                  ? COPIES.emptyState.search.title
                  : COPIES.emptyState.conversations.title
              }
              subtitle={
                searchKeyword
                  ? COPIES.emptyState.search.subtitle
                  : COPIES.emptyState.conversations.subtitle
              }
              customEmptyState={<SvgNoHiringAuthority height={300} />}
            />
          </EmptyListContainer>
        </When>

        <List disablePadding>
          {conversations.map(conversation => {
            const isChecked = selectedConversations.some(sel => sel.id === conversation.id);
            return (
              <ConversationListItem
                key={conversation.id}
                conversation={conversation}
                isChecked={isChecked}
                isSelected={selectedConversationId === conversation.id}
                onClickCheckbox={onClickCheckbox}
                onClickConversation={handleClickConversation}
                shouldTruncate
                showCheckbox={showCheckbox}
              />
            );
          })}
        </List>

        {isLoading && <LoaderContent color="primary" />}

        <div ref={listEndRef} />
      </ListContainer>
    </Container>
  );
};
